import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import Components from "./components";
import Directives from "./directives";

@NgModule({
  declarations: [...Components, ...Directives],
  imports: [CommonModule, MatProgressSpinnerModule],
  exports: [...Components, ...Directives]
})
export class UiModule {}
